(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.track    = this.querySelector('.hero-slideshow__track');
    this.slides   = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
    this.dots     = Array.from(this.querySelectorAll('.hero-slideshow__dot'));
    this.prevBtn  = this.querySelector('.hero-slideshow__arrow--prev');
    this.nextBtn  = this.querySelector('.hero-slideshow__arrow--next');
    this.pauseBtn = this.querySelector('.hero-slideshow__pause');
    this.total    = this.slides.length;
    this.index    = 0;
    this.timer    = null;
    this.paused   = false;

    this._initConfetti();

    this.addEventListener('click', (e) => {
      const card = e.target.closest('[data-slide-href]');
      if (!card) return;
      if (e.target.closest('a')) return;
      const url = card.dataset.slideHref;
      if (url) window.location.href = url;
    });

    if (this.total <= 1) {
      // Even with one slide, still need to toggle split class
      this._toggleSplitClass();
      return;
    }

    this.autoplay      = this.dataset.autoplay === 'true';
    this.speed         = parseInt(this.dataset.speed, 10) || 6000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reducedMotion) this.paused = true;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { this.go(i); this.restart(); });
    });

    if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.togglePause());

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { this.go(this.index - 1); this.restart(); }
      if (e.key === 'ArrowRight') { this.go(this.index + 1); this.restart(); }
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => { if (!this.paused) this.start(); });
    this.addEventListener('focusin',    () => this.stop());
    this.addEventListener('focusout',   () => { if (!this.paused) this.start(); });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else if (!this.paused) this.start();
    });

    this._setupSwipe();
    this.update(false);
    if (this.autoplay && !this.paused) this.start();
  }

  go(i) {
    this.index = (i + this.total) % this.total;
    this.update(true);
  }

  update(resetDot) {
    this.slides.forEach((s, i) => {
      const active = i === this.index;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      const wasActive = dot.classList.contains('is-active');

      if (resetDot && wasActive && !active) {
        dot.style.setProperty('--anim', 'none');
        void dot.offsetWidth;
        dot.style.removeProperty('--anim');
      }

      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');

      if (active && resetDot) {
        dot.classList.remove('is-active');
        void dot.offsetWidth;
        dot.classList.add('is-active');
      }
    });

    this.style.setProperty('--active-index', this.index);

    // Toggle split-active class so CSS can switch track height mode
    this._toggleSplitClass();
  }

  _toggleSplitClass() {
    const activeSlide = this.slides[this.index];
    const isSplit = activeSlide && activeSlide.classList.contains('hsc-split-slide');
    this.classList.toggle('hero-slideshow--has-split-active', isSplit);
  }

  start() {
    this.stop();
    if (!this.autoplay || this.total <= 1) return;
    this.classList.remove('hero-slideshow--paused');
    this.timer = setInterval(() => this.go(this.index + 1), this.speed);
  }
  stop() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }
  restart() { if (!this.paused) this.start(); }

  togglePause() {
    this.paused = !this.paused;
    this.pauseBtn.setAttribute('aria-pressed', String(this.paused));
    this.classList.toggle('hero-slideshow--paused', this.paused);
    const iP = this.pauseBtn.querySelector('.hero-slideshow__pause-icon--pause');
    const iL = this.pauseBtn.querySelector('.hero-slideshow__pause-icon--play');
    if (iP) iP.hidden = this.paused;
    if (iL) iL.hidden = !this.paused;
    this.paused ? this.stop() : this.start();
  }

  _setupSwipe() {
    let startX = 0, startY = 0;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      this.stop();
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) * 1.2 && Math.abs(dx) > 40) {
        this.go(dx > 0 ? this.index - 1 : this.index + 1);
      }
      this.restart();
    }, { passive: true });

    this.track.addEventListener('touchcancel', () => this.restart(), { passive: true });

    let dragging = false;
    this.track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      startX = e.clientX;
      dragging = true;
      this.stop();
    });
    this.track.addEventListener('pointerup', (e) => {
      if (e.pointerType === 'touch' || !dragging) return;
      dragging = false;
      const diff = e.clientX - startX;
      if (Math.abs(diff) > 40) this.go(diff > 0 ? this.index - 1 : this.index + 1);
      this.restart();
    });
    this.track.addEventListener('pointercancel', () => { dragging = false; this.restart(); });
  }

  _initConfetti() {
    this.querySelectorAll('[data-confetti="true"] .hsc-confetti-canvas').forEach((canvas) => {
      const slide = canvas.closest('.hero-slideshow__slide');
      if (!slide) return;
      const ctx = canvas.getContext('2d');
      let raf, particles = [];
      const COLORS = ['#ff6b6b','#ffd93d','#6bcb77','#4d96ff','#ff922b','#cc5de8','#f06595','#74c0fc'];

      const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };

      const spawn = () => {
        particles = Array.from({ length: 80 }, () => ({
          x:     Math.random() * canvas.width,
          y:     -10 - Math.random() * canvas.height * 0.4,
          size:  4 + Math.random() * 7,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          vx:    (Math.random() - 0.5) * 1.6,
          vy:    1.5 + Math.random() * 2.5,
          rot:   Math.random() * Math.PI * 2,
          rotV:  (Math.random() - 0.5) * 0.14,
          shape: Math.random() > 0.45 ? 'rect' : 'circle',
        }));
      };

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        let alive = false;
        particles.forEach((p) => {
          p.x += p.vx; p.y += p.vy; p.rot += p.rotV; p.vy += 0.04;
          if (p.y < canvas.height + 20) alive = true;
          ctx.save();
          ctx.globalAlpha = 0.9;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          if (p.shape === 'rect') {
            ctx.fillRect(-p.size / 2, -p.size / 3.5, p.size, p.size / 2.5);
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
        });
        if (alive) raf = requestAnimationFrame(draw);
      };

      const launch = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        cancelAnimationFrame(raf);
        resize();
        spawn();
        draw();
      };

      new MutationObserver(() => {
        if (slide.classList.contains('is-active')) launch();
      }).observe(slide, { attributes: true, attributeFilter: ['class'] });

      if (slide.classList.contains('is-active')) setTimeout(launch, 100);
      window.addEventListener('resize', resize, { passive: true });
    });
  }
}

if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', HeroSlideshow);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
